import { CardPageLayout } from '@repo/ccc-main-app-lib/src/pages/CardPageLayout.tsx'
import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/user/$userId/card')({
  component: CardPageLayoutRoute,
})

function CardPageLayoutRoute() {
  const { userId } = Route.useParams()

  return (
    <CardPageLayout userId={userId}>
      <Outlet />
    </CardPageLayout>
  )
}
